import {HTTP} from '@/CallAPI'
export default {
  getAllSummary (checklist) {
    return HTTP.get('checklists/' + checklist.id + '/meeting-minutes')
  },

  createSummary (checklist, data) {
    return HTTP.post('checklists/' + checklist.id + '/meeting-minutes', data)
  },

  showSummary (checklist, summary) {
    return HTTP.get('checklists/' + checklist.id + '/meeting-minutes/' + summary.id)
  },

  getChecklistItemReport (checklist) {
    return HTTP.get('checklists/' + checklist.id + '/meeting-minutes/checklist-items')
  },

  getResult (checklist) {
    return HTTP.get('checklists/' + checklist.id + '/result')
  },

  getMinutesLast (checklist) {
    return HTTP.get('checklists/' + checklist.id + '/meeting-minutes-last')
  }
}



// WEBPACK FOOTER //
// ./src/service/summary.js